import React from 'react';
import { Minus, Plus } from 'lucide-react';

const QuantitySelector = ({ 
  value, 
  onChange, 
  maxQuantity, 
  disabled 
}) => {
  const handleIncrease = () => {
    if (value < maxQuantity) {
      onChange(value + 1);
    }
  };

  const handleDecrease = () => {
    if (value > 1) {
      onChange(value - 1);
    }
  };

  return (
    <div className="quantity-selector">
      <div className="d-flex align-items-center mb-2">
        {/* <label className="form-label mb-0 me-2">Quantité:</label> */}
        <small className="text-muted">
          ({maxQuantity} disponible{maxQuantity > 1 ? 's' : ''})
        </small>
      </div>
      
      <div className="input-group" style={{ maxWidth: '200px' }}>
        <button
          type="button"
          onClick={handleDecrease}
          disabled={disabled || value <= 1}
          className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
        >
          <Minus size={18} />
        </button>

        <span className="form-control text-center bg-white" style={{ maxWidth: '60px' }}>
          {value}
        </span>

        <button
          type="button"
          onClick={handleIncrease}
          disabled={disabled || value >= maxQuantity}
          className="btn btn-outline-secondary d-flex align-items-center justify-content-center"
        >
          <Plus size={18} />
        </button>
      </div>

      <style>
        {`
          .quantity-selector .btn:focus {
            box-shadow: none;
          }
          .quantity-selector .form-control {
            border-left: none;
            border-right: none;
            pointer-events: none;
          }
          .quantity-selector .form-control:focus {
            box-shadow: none;
            border-color: #dee2e6;
          }
        `}
      </style>
    </div>
  );
};

export default QuantitySelector;